import { Dispatch } from 'redux';
import CrudActionContainer from './CrudActionContainer';
import commonHandler, {
  permissionsHandler,
} from '../errorHandlers/common-handler';
import { IceBreakerController } from '../controllers/IceBreakerController';
import { StoreState } from '../store-interfaces';
import { IceBreakerKind, IceBreakerModel } from '../model/IceBreakerModel';
import { getActionHookBuilder } from './action-hook-builder';

type IceBreakersResponse = { iceBreaker: IceBreakerModel };

class IceBreakerCRUDActions extends CrudActionContainer {
  constructor() {
    super('ICE_BREAKERS');
  }

  retrieveAll(botId: number, platform: IceBreakerKind, token?: string) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));
      try {
        const response: IceBreakersResponse = await IceBreakerController.getAll(
          botId,
          platform,
          token,
        );
        const { iceBreaker } = response;
        const call =
          platform === 'instagram' ? this.retrievedAllIG : this.retrievedAllFB;
        dispatch(call.bind(this)([iceBreaker]));
        return iceBreaker;
      } catch (e) {
        permissionsHandler(dispatch, this)(e);
      }
    };
  }

  update(botId: number, entity: Partial<IceBreakerModel>) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.updateAction));
      try {
        const response = await IceBreakerController.putIceBreaker(
          botId,
          entity,
        );
        const { iceBreaker } = response;
        dispatch(this.updateLocal(iceBreaker));
        return iceBreaker;
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  }

  retrievedAllFB<T>(entities: IceBreakerModel[]) {
    return {
      type: this.retrievedAllAction,
      entities,
      kind: 'facebook',
    };
  }

  retrievedAllIG<T>(entities: IceBreakerModel[]) {
    return {
      type: this.retrievedAllAction,
      entities,
      kind: 'instagram',
    };
  }
}

const iceBreakerCRUDActions = new IceBreakerCRUDActions();

export const useIceBreakerCRUDActions = getActionHookBuilder(
  iceBreakerCRUDActions,
  ['retrieveAll', 'update'],
);

export default iceBreakerCRUDActions;
